export { default } from './PrismTemplateParts';
